<dx-popup title="Select" [width]="600" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dxi-popup-toolbar-item
        widget="dxButton"
        location="after"
        [options]="{
            icon: 'save',
            text: 'Select',
            accessKey: 's',
            type: 'success',
            onClick: select,
            disabled: !list?.selectedItems.length
        }"
    >
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item
        widget="dxButton"
        location="after"
        [options]="{ icon: 'close', text: 'Clear', type: 'default', onClick: clear }"
        [visible]="allowClear"
    >
    </dxi-popup-toolbar-item>
    <div *dxTemplate="let data of 'content'">
        <dx-list
            #list
            [dataSource]="items"
            [height]="400"
            width="100%"
            [searchEnabled]="true"
            searchExpr="name"
            selectionMode="single"
            pageLoadMode="scrollBottom"
        >
            <div *dxTemplate="let data of 'item'">
                <div>{{ data.name }}</div>
            </div>
        </dx-list>
    </div>
</dx-popup>
